import React, {useState, useContext, useEffect} from 'react'
import '../assets/styles/ExternalCreateApplication.css'
import {AuthContext} from '../AuthContext';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ExternalForm from '../components/ExternalForm'
import Spinner from 'react-spinner-material';
import ContactInformationForm from '../components/CommercialLoan/ContactInformationForm';
import Accordeon from '../components/general/Accordeon';

const ExternalFillOwnerInformation = () => {

    const{isAuth, uri} = useContext(AuthContext);

    const formId = useParams().id;

    const [formData, setFormData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [notFound, setNotFound] = useState(false)

    

    //GET DETAILS FROM APPLICATION ID
    useEffect(() => {
        setIsLoading(true)

        const abortController = new AbortController();
        const signal = abortController.signal;

        const URI = `${uri.URI_PROTOCOL}${uri.URI_ENV}${uri.URI_BASE}${uri.URI_VERSION}commercial-application/get-commercial-owner/${formId}`;

        window.fetch(URI, {
            method: 'GET',
            signal: signal,
            headers: {
                'x-api-key': uri.URI_X_API_KEY,
            },
        })
            .then(response => response.json())
            .then(datos => {
                setIsLoading(false)
                console.log(datos)

                if(datos.status === 'NOT_FOUND'){
                    setNotFound(true)
                }else{
                    setFormData([datos])
                }

               

            })
            .catch(error => {
                setIsLoading(false)
                console.log(error)
            })

        return function cleanup() {
            abortController.abort();
        }
    }, []);






    return (
        <div className={isAuth ? "externalFormPage_mainContainer externalFormPage_marginLeft" : "externalFormPage_mainContainer"}>
            {isAuth ? null : <Header />}
            <div className="externalFormPage_formContainer">
                {
                    isLoading ?
                    <Spinner
                        radius={35}
                        color={"grey"}
                        stroke={5}
                        visible={true}
                    />
                        

                    :

                    notFound ? 
                    <p>Not found</p>

                    :

                   // <ExternalForm applicationId={formData.ProspectLoanApplicationId} type="create"/>
                   <div style={{maxWidth: '655px'}}>
                    <Accordeon title="Ownership/Contact Information" isCompleted={false} id="contactForm" open={true} hideIcon>
                        <ContactInformationForm 
                            type={"create"}
                            prefilledInfo={formData}
                            isExternalForm
                            ownerId={formId}
                        />
                   </Accordeon>
                   </div>
                   
                    

                    
                }
               
            </div>   
            {isAuth ? null : <Footer />}
        </div>
    )
}

export default ExternalFillOwnerInformation